import { MASHING_AND_COLLECTION_TITLES } from './mashingAndCollectionTitles';
import { getMashingInfo } from './mashingAndCollectionMoreInfo';
import { getMashingTable } from './mashingAndCollectionTable';

export const getMashingAndCollectionFields = props => [
  MASHING_AND_COLLECTION_TITLES,
  ...getMashingTable(props),
  ...getMashingInfo(props)
];
